import React from 'react';
import { Grid, Typography, Paper } from '@mui/material';

interface AlarmMessagesGridProps {
  alarmMessages?: string;
}

const AlarmMessagesGrid: React.FunctionComponent<AlarmMessagesGridProps> = (props) => {
  const { alarmMessages } = props;

  if (!alarmMessages) {
    return (
      <Typography variant="body2" color="textSecondary">
        No alarm messages
      </Typography>
    );
  }

  // Split by |~| delimiter (or fallback to semicolon for old data) and clean up newlines within messages
  const delimiter = alarmMessages.includes('|~|') ? '|~|' : ';';
  const messages = alarmMessages
    .split(delimiter)
    .map((msg) => msg.replace(/[\r\n]+/g, ', ').trim())
    .filter((msg) => msg.length > 0);

  return (
    <Grid container spacing={1}>
      {messages.map((message, index) => (
        <Grid item xs={12} key={index}>
          <Paper
            elevation={1}
            style={{
              padding: '8px 12px',
              backgroundColor: '#fff3cd',
              borderLeft: '4px solid #ffc107',
            }}
          >
            <Typography variant="body2" style={{ fontSize: '13px' }}>
              {index + 1}. {message}
            </Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default AlarmMessagesGrid;
